import type { IResource, ISchedule } from "@gettactic/api";
import { getScheduleRooms } from "@gettactic/helpers/src/schedules/getScheduleRooms";
import { getEditedReservationRoomIds } from "./getEditedReservationRoomIds";

/**
 * The rooms a split of a recurring reservation has to book on top of the one the form
 * points at.
 *
 * Editing "this and future" from a later occurrence truncates the original series and
 * creates the future one from scratch, so that new series only holds the rooms it is
 * handed: without these, every future occurrence keeps just the form's room and the rest
 * are dropped. The set matches what an in-place edit would keep — the primary is swapped
 * for the form's room and the others travel along — so both paths land on the same rooms.
 */
export const getEditedReservationExtraRooms = (
  original: ISchedule,
  selectedRoomId: string
): IResource[] => {
  const keptIds = new Set(
    getEditedReservationRoomIds(original, selectedRoomId)
  );

  return getScheduleRooms(original).filter(
    (room) => room.id !== selectedRoomId && keptIds.has(room.id)
  );
};
